var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_33",
    "data-name": "Component 3 \\u2013 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 1,
    viewBox: "0 0 96 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 96,
    height: 1,
    fill: "#8294a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLine);
export default __webpack_public_path__ + "static/media/grey-line.5af4845a0e5ba4bcddd133de1edafc6d.svg";
export { ForwardRef as ReactComponent };